import { forwardRef } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Box, Card, CardContent } from "@mui/material"
import { resolveAsFunction } from "lib/resolve-as-function"
import { useMeasurement } from "lib/@hooks/useMeasurement"
import { NoResults } from "lib/@components/no-results/no-results"

export const PopupContent = forwardRef(function PopupContent(
    { optionContent, content, noOptionsText = "No options", ...props },
    ref
) {
    const { ContentWrapper } = useBoundContext()
    const [size, attach] = useMeasurement()

    return (
        <Card ref={ref} {...props}>
            <Box ref={attach}>
                <ContentWrapper>
                    {resolveAsFunction(content)()}
                    {optionContent}
                </ContentWrapper>
            </Box>
            {size.height < 41 && (
                <CardContent>
                    <NoResults>{noOptionsText}</NoResults>
                </CardContent>
            )}
        </Card>
    )
})
